module.exports = __webpack_public_path__ + "img/health_form_elements_icon.d9cbcbbe.svg";